import { useMemo } from 'react';
import { useConfiguration } from '~/context/common/StaticContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import { Narrative } from '~/contracts/vdp/Narratives';
import { getNarrative } from '~/utilities/vdp/whyBuyNarrative';

export default function useGetVaultWhyBuyNarrative(): Narrative {
  const configuration = useConfiguration();
  const { narratives } = useGetVehicleDetails();

  return useMemo(() => {
    return getNarrative(configuration.VaultWhyBuyNarrativeConfig, narratives);
  }, [configuration.VaultWhyBuyNarrativeConfig, narratives]);
}
